import React from 'react';

import { UI_TEXT } from './constants';
import styles from './MultiSelectDropDown.module.css';

const NoResults = () => <div className={styles.noResults}>{UI_TEXT.NO_RESULTS}</div>;

export default NoResults;
